import { useState, useEffect } from 'react';
import { VStack, HStack, Text } from 'native-base';

// Assets
import { theme } from '@breakroom-nx/assets';

// Classes & Types
import { User, getUserData, Comment } from '@breakroom-nx/classes';
import { UserAvatar, VotingButton, FeedbackType } from '../../';
import {
  useVoteOnFeedbackMutation,
  useGetCurrentUserQuery,
} from '@breakroom-nx/redux';

import { timeFrom } from '@breakroom-nx/helpers';

export interface CommentCellProps {
  data: Comment;
}

export function CommentCell({ data }: CommentCellProps) {
  const { data: currentUser } = useGetCurrentUserQuery();
  const [vote, voteState] = useVoteOnFeedbackMutation();
  const [creator, setCreator] = useState<User | null>();

  // const modifyVote = (upvote: boolean) => {
  //   console.log(`Vote Made: ${upvote}`);
  //   if (currentUser) {
  //     vote({ user: currentUser, feedbackID: data.uid, type, upvote })
  //       .unwrap()
  //       .then(() => {
  //         if (upvote) {
  //           if (feedback === FeedbackType.Praise) {
  //             setFeedback(FeedbackType.None);
  //           } else {
  //             setFeedback(FeedbackType.Praise);
  //           }
  //         } else {
  //           if (feedback === FeedbackType.Scold) {
  //             setFeedback(FeedbackType.None);
  //           } else {
  //             setFeedback(FeedbackType.Scold);
  //           }
  //         }
  //       })
  //       .catch((err) => {
  //         // Throw Error
  //       });
  //   }
  // };

  const updateCreatorData = async () => {
    const userData = await getUserData(data.creatorUID!);
    setCreator(userData);
  };

  useEffect(() => {
    if (data.creatorUID !== undefined) {
      updateCreatorData();
    }
  }, []);

  return (
    <VStack
      space={5}
      alignItems={'start'}
      alignContent={'stretch'}
      rounded={'lg'}
      p={5}
      mb={5}
      bg={theme.colors.surface[300]}
    >
      <HStack
        alignItems={'center'}
        justifyContent={'space-between'}
        alignContent={'space-between'}
        width={'full'}
      >
        {data.creatorUID ? (
          <HStack space={3} alignItems={'center'}>
            <UserAvatar uid={data.creatorUID} size={8} />
            <Text
              fontSize={16}
              variant={'usernameProfile'}
              color={'surface.500'}
              isTruncated
            >
              {creator?.username}
            </Text>
          </HStack>
        ) : null}
      </HStack>

      <Text color={'white'}>{data.comment}</Text>
      <HStack
        width={'full'}
        alignItems={'center'}
        justifyContent={'space-between'}
      >
        <Text color={theme.colors.surface[500]} fontSize={14} fontWeight={400}>
          {timeFrom(data.createdAt)}
        </Text>
      </HStack>
    </VStack>
  );
}

export default CommentCell;
